import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7098712f"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "frontend-asset-preview" };
const _hoisted_2 = { class: "mobile-phone-wrapper" };
const _hoisted_3 = ["src"];
const _hoisted_4 = { class: "mobile-phone-wrapper__screen" };
const _hoisted_5 = {
    key: 0,
    class: "mobile-phone-wrapper__screen__header"
};
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "badge" }, [
    /*#__PURE__*/ _createElementVNode("span", null, "Inbox")
], -1 /* HOISTED */));
const _hoisted_7 = { class: "mobile-phone-wrapper__screen__content" };
const _hoisted_8 = ["src"];
const _hoisted_9 = {
    key: 0,
    class: "qr-code-wrapper"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "qr-code-wrapper-instructions" }, [
    /*#__PURE__*/ _createElementVNode("p", null, " Scan this QR Code with your smart phone to open this preview on your device ")
], -1 /* HOISTED */));
import phoneFrameImage from "assets/phone-frame.png";
import { uniqueId } from "lodash";
import { computed, onMounted, ref, watch } from "vue";
import { useFrontendAssetPreviewUrl } from "./useFrontendAssetPreviewUrl";
import CampaignFrontendAssetPreviewToolbar from "./CampaignFrontendAssetPreviewToolbar.vue";
import { useQrCodeImageUrl } from "src/shared/tools/qr-code/useQrCodeImageUrl";
import { onBeforeRouteUpdate } from "vue-router";
import DebugDrawer from "./DebugDrawer.vue";
import Session from "js/Session";
import { isCreativeActionCampaignFrontendAsset } from "src/shared/store/campaign-built/model/frontend-asset/CreativeActionCampaignFrontendAsset";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CampaignFrontendAssetPreview',
    props: {
        frontendAsset: {},
        deviceTypeOverride: {},
        title: {},
        variantOverride: {},
        includeVariantSelector: { type: Boolean, default: true },
        inlcudeToolbar: { type: Boolean },
        showUploadDownloadControls: { type: Boolean, default: false }
    },
    setup(__props, { expose: __expose }) {
        const props = __props;
        const emailSubject = ref(null);
        const deviceType = ref("MOBILE");
        const isSuperUser = Session.getInstance().isSuperUser();
        const isDebugShown = ref(false);
        const iframe = ref(null);
        const iframeId = `iframe-${uniqueId()}`;
        const variant = ref(null);
        const { previewUrl } = useFrontendAssetPreviewUrl(() => props.frontendAsset, () => variant.value);
        const { qrCodeImageUrl } = useQrCodeImageUrl(previewUrl);
        const refreshTimestamp = ref(Date.now().toString());
        const refreshablePreviewUrl = computed(() => {
            if (!previewUrl.value) {
                return null;
            }
            const url = new URL(previewUrl.value);
            url.searchParams.set("refresh", refreshTimestamp.value);
            return url.toString();
        });
        const refreshIframe = () => {
            refreshTimestamp.value = Date.now().toString();
        };
        const bindToCreativePreviewIframeEvents = (iframeId, callback) => {
            window.addEventListener("message", (event) => {
                if (iframeId === event.data.name) {
                    callback(event);
                }
            });
        };
        const setEmailSubject = (newEmailSubject) => {
            emailSubject.value = newEmailSubject;
        };
        const isNumber = (value) => {
            return typeof value === "number";
        };
        const resizeIframe = (height) => {
            if (!iframe.value || !isNumber(height)) {
                return;
            }
            const shouldBe100PercentHeight = deviceType.value === "MOBILE";
            iframe.value.style.height = shouldBe100PercentHeight
                ? "100%"
                : `${height}px`;
        };
        const handleCreativePreviewIframeEvent = (event) => {
            switch (event.data.type) {
                case "HEIGHT":
                    resizeIframe(event.data.value);
                    break;
                case "EMAIL_SUBJECT":
                    setEmailSubject(event.data.value);
                    break;
                default:
                    window.console.log(`Unknown event type: ${event.data.type}`);
                    break;
            }
        };
        onMounted(() => {
            bindToCreativePreviewIframeEvents(iframeId, handleCreativePreviewIframeEvent);
        });
        const deviceTypePreviewClass = computed(() => {
            return `frontend-asset-preview__preview--${deviceType.value.toLowerCase()}`;
        });
        watch(() => props.frontendAsset.isDesktopPreviewOnly(), (isDesktopOnly) => {
            if (isDesktopOnly) {
                deviceType.value = "DESKTOP";
            }
        }, { immediate: true });
        watch(() => props.deviceTypeOverride, (newDeviceType) => {
            if (!props.frontendAsset.isDesktopPreviewOnly() && newDeviceType) {
                deviceType.value = newDeviceType;
            }
        }, {
            immediate: true,
        });
        watch(() => props.variantOverride, (newVariant) => {
            if (newVariant) {
                variant.value = newVariant;
            }
        }, {
            immediate: true,
        });
        onBeforeRouteUpdate(() => {
            emailSubject.value = null;
        });
        const downloadUrl = computed(() => {
            if (isCreativeActionCampaignFrontendAsset(props.frontendAsset)) {
                return props.frontendAsset.getCreativeDownloadUrl(props.frontendAsset.getDisplayName());
            }
            return null;
        });
        __expose({
            refresh: refreshIframe,
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(CampaignFrontendAssetPreviewToolbar, {
                    class: "frontend-asset-preview__toolbar",
                    "frontend-asset": _ctx.frontendAsset,
                    "preview-url": _unref(previewUrl),
                    title: _ctx.title,
                    "include-variant-selector": _ctx.includeVariantSelector,
                    "show-upload-download-controls": _ctx.showUploadDownloadControls,
                    variant: variant.value,
                    "onUpdate:variant": _cache[0] || (_cache[0] = ($event) => ((variant).value = $event)),
                    "device-type": deviceType.value,
                    "onUpdate:deviceType": _cache[1] || (_cache[1] = ($event) => ((deviceType).value = $event)),
                    "debug-shown": isDebugShown.value,
                    "onUpdate:debugShown": _cache[2] || (_cache[2] = ($event) => ((isDebugShown).value = $event)),
                    onOnRefresh: refreshIframe
                }, null, 8 /* PROPS */, ["frontend-asset", "preview-url", "title", "include-variant-selector", "show-upload-download-controls", "variant", "device-type", "debug-shown"]),
                (isDebugShown.value && refreshablePreviewUrl.value && _unref(isSuperUser))
                    ? (_openBlock(), _createBlock(DebugDrawer, {
                        key: 0,
                        url: refreshablePreviewUrl.value,
                        "is-shown": isDebugShown.value,
                        "onUpdate:isShown": _cache[3] || (_cache[3] = ($event) => ((isDebugShown).value = $event))
                    }, null, 8 /* PROPS */, ["url", "is-shown"]))
                    : _createCommentVNode("v-if", true),
                _createElementVNode("div", {
                    class: _normalizeClass(["frontend-asset-preview__preview", deviceTypePreviewClass.value])
                }, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("img", { src: _unref(phoneFrameImage) }, null, 8 /* PROPS */, _hoisted_3),
                        _createElementVNode("div", _hoisted_4, [
                            (emailSubject.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    _createElementVNode("span", null, [
                                        _createTextVNode(_toDisplayString(emailSubject.value) + " ", 1 /* TEXT */),
                                        _hoisted_6
                                    ])
                                ]))
                                : _createCommentVNode("v-if", true),
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("iframe", {
                                    class: "frontend-asset-preview__iframe",
                                    src: refreshablePreviewUrl.value || '',
                                    ref_key: "iframe",
                                    ref: iframe,
                                    name: iframeId,
                                    frameborder: "0"
                                }, null, 8 /* PROPS */, _hoisted_8)
                            ])
                        ])
                    ]),
                    (_unref(qrCodeImageUrl))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("img", { src: _unref(qrCodeImageUrl) }, null, 8 /* PROPS */, _hoisted_10),
                            _hoisted_11
                        ]))
                        : _createCommentVNode("v-if", true)
                ], 2 /* CLASS */)
            ]));
        };
    }
});
